// extracted by mini-css-extract-plugin
export var formContainer = "_jw-0";
export var message = "_jw-1";